var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { withTheme } from "styled-components";
import Box from "../../box/Box";
import Icon from "../../icon/Icon";
import { MdCheckBox, MdCheckBoxOutlineBlank, MdRadioButtonUnchecked, MdRadioButtonChecked, } from "react-icons/md";
var CheckToggleIcon = function (_a) {
    var checked = _a.checked, rest = __rest(_a, ["checked"]);
    return checked ? (React.createElement(Icon, __assign({ size: 24, icon: MdCheckBox }, rest))) : (React.createElement(Icon, __assign({ size: 24, icon: MdCheckBoxOutlineBlank }, rest)));
};
var RadioToggleIcon = function (_a) {
    var checked = _a.checked, rest = __rest(_a, ["checked"]);
    return checked ? (React.createElement(Icon, __assign({ size: 24, icon: MdRadioButtonChecked }, rest))) : (React.createElement(Icon, __assign({ size: 24, icon: MdRadioButtonUnchecked }, rest)));
};
function ToggleIcon(_a) {
    var theme = _a.theme, checked = _a.checked, type = _a.type;
    var Comp = type === "radio" ? RadioToggleIcon : CheckToggleIcon;
    return (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center" },
        React.createElement(Comp, { checked: checked, size: 22, color: checked
                ? theme.component.toggle.active.borderColor
                : theme.component.toggle.initial.borderColor })));
}
ToggleIcon.defaultProps = {
    type: "checkbox",
};
export default withTheme(ToggleIcon);
//# sourceMappingURL=ToggleIcon.js.map